import { Box } from "@mui/material";
import PanelHeader from "./PanelHeader";
import PanelFooter from "./PanelFooter";

const sx = {
  root: (theme) => ({
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: { xs: 0, sm: "8px" },
    backgroundColor: theme.palette.background.paper,
    overflow: "hidden",
    height: "100%",
  }),
  body: {
    flex: 1,
    overflow: "auto",
    p: 1.5,
    scrollbarWidth: "thin",
    scrollbarColor: "#CBD5E1 transparent",
    "&::-webkit-scrollbar": {
      width: "9px",
      height: "9px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#CBD5E1",
      borderRadius: "6px",
      border: "2px solid transparent",
      backgroundClip: "padding-box",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#94A3B8",
      borderRadius: "6px",
      border: "2px solid transparent",
      backgroundClip: "padding-box",
    },
    "& *::-webkit-scrollbar": {
      width: "9px",
      height: "9px",
    },
    "& *::-webkit-scrollbar-thumb": {
      backgroundColor: "#CBD5E1",
      borderRadius: "6px",
      border: "2px solid transparent",
      backgroundClip: "padding-box",
    },
    "& *": {
      scrollbarWidth: "thin",
      scrollbarColor: "#CBD5E1 transparent",
    },
  },
};

const Panel = ({ title, titleContent, headerActions, footer, children }) => (
  <Box sx={sx.root}>
    <PanelHeader title={title} titleContent={titleContent}>{headerActions}</PanelHeader>
    <Box sx={sx.body}>{children}</Box>
    {footer && <PanelFooter>{footer}</PanelFooter>}
  </Box>
);

export default Panel;
